<p-popover #popover [dismissable]="false" appendTo="body" styleClass="p-overlaypanel--dark">
<!--    <ng-template pTemplate>-->
        <article style="min-width: 492px">
            <button (click)="hide()" class="bulb-overlaypanel__close">
                <svg-icon class="p-button-icon" key="times" fontSize="2em"></svg-icon>
            </button>

            <bulb-share-form
              [unitId]="unitId"[compositeUnit]="compositeUnit"
              [parentUnitId]="parentUnitId"
            >
            </bulb-share-form>

        </article>
<!--    </ng-template>-->
</p-popover>
